import { DETAIL_ESG, LAYERS } from '@/constants'

/**
 * Patches LAYERS and DETAIL_ESG in-place with dynamically resolved WMS layer versions.
 * Called once in app.js setup before any component mounts. Since useDetailMapHelpers'
 * Map stores references to the same LAYERS objects, mutations propagate automatically.
 *
 * @param {Object|null} layerConfig - From backend getFrontendLayerConfig():
 *   { heat_islands: { layer, frontendLayerId, legendUrl }, ... }
 *   An entry may also carry `url` when the service base itself is resolved at
 *   runtime (the rotating XGIS2 id behind yp-maakasutus, RED-293).
 */
export function patchWmsLayers(layerConfig) {
  if (!layerConfig) return

  for (const [esgKey, config] of Object.entries(layerConfig)) {
    if (!config.frontendLayerId || !config.layer) continue

    const layer = LAYERS.find(l => l.id === config.frontendLayerId)
    if (layer?.params?.LAYERS) {
      layer.params.LAYERS = config.layer
    }
    if (layer && config.url) {
      layer.url = config.url
    }

    if (config.legendUrl && DETAIL_ESG[esgKey]) {
      DETAIL_ESG[esgKey].legends = [config.legendUrl]
    }
  }
}
